import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    liquidStaking: 'LIQUID STAKING',
    deprecatedLiquidStaking: '{token} DEPRECATED VERSION',
    apy: 'APY',
    tvl: 'TVL',
    opportunities: 'opportunities',
    deFi: 'DeFi',
  },
};
